import { Link } from "react-router-dom";

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑" className="w-full">
      <ol className="flex flex-wrap items-center gap-1 text-xs text-foreground-500 md:text-sm">
        {items.map((item, i) => (
          <li key={`${item.label}-${i}`} className="flex items-center gap-1">
            {item.href ? (
              <Link to={item.href} className="transition-colors hover:text-primary-600">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800">{item.label}</span>
            )}
            {i < items.length - 1 && (
              <span className="flex h-3.5 w-3.5 items-center justify-center text-foreground-400">
                <i className="ri-arrow-right-s-line text-base" />
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}